//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import VueMq from "vue-mq";

import { ConfigService } from "@nuskin/ns-util";

import { getImagesFromJson } from "../utils/helpers";

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

const nsTopnavProductLine = {
  name: "NsTopnavProductLine",
  props: {
    /**
     * Product items (max: 3)
     * [{image, alt, text, link, desc}]
     */
    items: {
      type: String,
      default: JSON.stringify([])
    }
  },
  data: function() {
    return {
      localItems: []
    };
  },
  computed: {
    itemsArray() {
      const marketConfig = ConfigService.getMarketConfig();
      return (getImagesFromJson(marketConfig.siteUrl, this.items) || []).filter(
        item => item.image || item.text
      );
    }
  }
};

export default nsTopnavProductLine;
